var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        staticClass: "projects-lower-bar-button-path",
        attrs: {
          d:
            "M6.66699 1.33325L6.00033 1.99992H2.66699V3.33325H13.3337V1.99992H10.0003L9.33366 1.33325H6.66699ZM3.33366 4.66659V13.3333C3.33366 14.0666 3.93366 14.6666 4.66699 14.6666H11.3337C12.067 14.6666 12.667 14.0666 12.667 13.3333V4.66659H3.33366ZM5.33366 5.99992H6.66699V13.3333H5.33366V5.99992ZM9.33366 5.99992H10.667V13.3333H9.33366V5.99992Z",
          fill: "CurrentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }